//import React, { useEffect, useState } from "react";
import React, { useState } from "react";
import coursesData from "./courses.json";

const CourseList = () => {
  const [courses] = useState(coursesData);
 

// //const API_URL = "https://mocki.io/v1/715c487d-e74f-4b34-9c04-829e0487a487";
// const API_URL ="https://mocki.io/v1/fa4b9f04-0d07-4fb2-984c-4cc6edd17e41";
//  //const API_URL = "https://mocki.io/v1/f7cb0d96-2777-4326-9ebb-66b101925ac5";

// const CourseList = () => {
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const res = await fetch(API_URL);
//         if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         const data = await res.json();
//         // Ensure data is an array
//         setCourses(Array.isArray(data) ? data : []);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load courses. Check console for details.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCourses();
//   }, []);

//   if (loading) {
//     return (
//       <div className="min-h-[50vh] flex items-center justify-center">
//         <p className="text-lg font-medium">Loading courses...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="max-w-xl mx-auto text-center p-6">
//         <p className="text-red-600 font-semibold mb-3">{error}</p>
//         <p className="text-sm text-gray-600">
//           If the API URL is incorrect or CORS blocks the request, try the
//           alternate URL printed in the README or open the browser console.
//         </p>
//       </div>
//     );
//   }

   return (
    <div className="max-w-5xl mx-auto p-4">
      <h1 className="text-3xl font-bold text-center mb-6 text-blue-600">
        Available Courses
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {courses.map((course, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow p-4 hover:shadow-lg transition"
          >
            <img
              src={course.image}
              alt={course.courseName}
              className="h-40 w-full object-cover rounded mb-3"
            />

            <h2 className="text-lg font-semibold">
              {course.courseName}
            </h2>

            <p className="text-sm text-gray-600">
              <b>Instructor:</b> {course.instructor}
            </p>

            <p className="text-sm text-gray-600">
              <b>Duration:</b> {course.duration}
            </p>

            <p className="text-sm text-gray-600">
              <b>Mode:</b> {course.mode}
            </p>

            <div className="flex justify-between items-center mt-3">
              <span className="text-blue-600 font-bold">
                {course.price}
              </span>
              <button className="bg-blue-600 text-white px-3 py-1 rounded text-sm">
                Enroll
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseList;